@if (isVisible()) {
  <div
    [class]="'side-panel-backdrop ' + animationState()"
    (click)="handleClose('backdrop')"
    aria-hidden="true"
  ></div>

  <div
    [class]="noOfColumns()"
    [id]="id()"
    role="dialog"
    [style.z-index]="999991 + zIndexOffset() * 2"
    [attr.aria-labelledby]="effectiveTitle()"
    aria-modal="true"
    tabindex="-1"
  >
    @if (!effectiveHideHeader()) {
      <div class="side-panel-header d-flex justify-content-between align-items-center"
        [ngClass]="isMobileLarge() ? 's-p-20' : (_storeSvc.RTL_Flag()
        ? 'pb-32 pt-3 pe-32 ps-3' : 'pb-32 pt-3 ps-32 pe-3')">
        <h2 class="side-panel-title mb-0"
          [ngClass]="isMobileLarge()
          ? (_storeSvc.RTL_Flag() ? 'font-weight-semibold ps-5' : 'font-weight-semibold pe-5')
          : (_storeSvc.RTL_Flag() ? 'font-weight-normal ps-32' : 'font-weight-normal pe-32')"
        >
          {{ effectiveTitle() }}
        </h2>
        @if (!effectiveHideCloseButton()) {
          <div class="side-panel-close d-block"
            [ngClass]="isMobileLarge()
            ? (_storeSvc.RTL_Flag() ? 'float-start' : 'float-end')
            : (_storeSvc.RTL_Flag() ? 'text-start' : 'text-end')"
          >
            <app-button class="d-block" variant="close" label="Close Button" (onClickEvent)="handleClose('btn')" />
          </div>
        }
      </div>
    }
    <div
      class="side-panel-content h-100 {{ effectiveContentClasses() }}"
      [class.full-max-height]="effectiveFullMaxHeight()"
      [class.s-px-20]="isMobileLarge()"
      [class.s-pb-20]="isMobileLarge()"
    >
      @if (contentTemplate()) {
        <ng-container [ngTemplateOutlet]="contentTemplate()!" />
      } @else {
        <ng-content></ng-content>
      }
    </div>
  </div>
}
